function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from './spzaComponent';
import { getElement } from '../utils/appUtils';
import { Constants } from '../utils/constants';
import { SpzaInstrumentService } from '../services/telemetry/spza/spzaInstrument';
import { getWindow } from '../services/window';
import { logger } from '@src/logger';
// Displays long content with more and less switches
export class LongContent extends SpzaComponent {
    changeExpandedState() {
        this.setState((prevState)=>{
            return {
                isExpanded: !prevState.isExpanded,
                showExpansionButton: prevState.showExpansionButton,
                processed: prevState.processed
            };
        });
        const payload = {
            page: getWindow().location.href,
            action: this.state.isExpanded ? Constants.Telemetry.Action.Collapse : Constants.Telemetry.Action.Expand,
            // if this is used somewhere else than my reviews need to update it by passing in with props
            // to determine where is 'more' clicked
            actionModifier: Constants.Telemetry.ActionModifier.ReviewItemMoreButton
        };
        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
        logger.info('', {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
    }
    isLongContent() {
        const longContent = getElement(Constants.SearchBy.Id, this.longContentIdPrefix + this.props.entityId);
        return longContent && longContent.offsetHeight > this.props.clipHeight;
    }
    setStateBasedOnContentLength() {
        if (this.isLongContent()) {
            this.setState({
                isExpanded: false,
                showExpansionButton: true,
                processed: true
            });
        } else {
            // Just updating the processed flag.
            this.setState((prevState)=>{
                return {
                    isExpanded: prevState.isExpanded,
                    showExpansionButton: prevState.showExpansionButton,
                    processed: true
                };
            });
        }
    }
    componentDidMount() {
        this.setStateBasedOnContentLength();
    }
    componentDidUpdate() {
        if (!this.state.processed) {
            this.setStateBasedOnContentLength();
        }
    }
    UNSAFE_componentWillReceiveProps() {
        // Reset to the original state so that more/less can be recalculated.
        this.state = {
            // By default every content is expanded
            isExpanded: true,
            // By default we should not show the expansion button
            showExpansionButton: false,
            // When new props are received, we have to reprocess this component.
            processed: false
        };
    }
    renderImpl() {
        if (!this.props.content) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: "c-content-toggle",
            children: [
                /*#__PURE__*/ _jsx("p", {
                    // eslint-disable-next-line react/forbid-dom-props
                    id: this.longContentIdPrefix + this.props.entityId,
                    className: this.state.isExpanded ? 'longContentExpanded' : 'longContentContracted',
                    children: /*#__PURE__*/ _jsx("span", {
                        itemProp: "description",
                        children: this.props.content
                    })
                }),
                !this.state.showExpansionButton ? null : /*#__PURE__*/ _jsx("button", {
                    className: "expansionButton",
                    onClick: this.changeExpandedState.bind(this),
                    children: this.state.isExpanded ? this.context.loc('LongContent_Less_Text') : this.context.loc('LongContent_More_Text')
                })
            ]
        });
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "longContentIdPrefix", 'longContent');
        this.state = {
            // By default every content is expanded
            isExpanded: true,
            // By default we should not show the expansion button
            showExpansionButton: false,
            processed: false
        };
    }
}
LongContent.contextTypes = {
    loc: PropTypes.func
};
